import { createNewHandbookApi } from '@/api/handbookApi'
import { POSITION_PROPERTY_URL } from '@/api/handbook/position'
import { createHandbookResponseErrors } from '@/utils/error/responseErrors'

const SURFACE_TREATMENT_URL = `${POSITION_PROPERTY_URL}/surface-treatments`

const errors = createHandbookResponseErrors('поверхностную обработку', 'поверхностных обработок')

export const SurfaceTreatmentApi = createNewHandbookApi(SURFACE_TREATMENT_URL, errors)
